import type { ApiError } from "@astro/types";

export class ApiRequestError extends Error {
  constructor(public readonly error: ApiError) {
    super(error.message);
    this.name = "ApiRequestError";
  }
}

export type { ApiError };
